const BroadcastService = {
  getBroadcasts: async (payload) => {
    const params = Object.keys(payload).map(key => `${encodeURIComponent(key)}=${encodeURIComponent(payload[key])}`).join('&');

    const { data, headers } = await ovpFetch(`/live/broadcast?${params}`);
    const pagination = {
      max_page: 1,
      current_page: payload.page,
    };

    const { link } = headers;
    if (link) {
      const linkSplit = link.split(',');
      const lastIndex = linkSplit.findIndex(rel => rel.includes('rel="last"'));
      const prevIndex = linkSplit.findIndex(rel => rel.includes('rel="prev"'));
      if (lastIndex > -1) {
        pagination.max_page = parseInt(linkSplit[lastIndex].match(/(?:&page=|\?page=)(\d+)/)[1], 10);
      } else if (prevIndex > -1) {
        pagination.max_page = parseInt(linkSplit[prevIndex].match(/(?:&page=|\?page=)(\d+)/)[1], 10) + 1;
      }
      pagination.current_page = pagination.max_page < pagination.current_page ? pagination.max_page : pagination.current_page;
    }

    return {
      broadcasts: data,
      pagination,
    };
  },

  updateBroadcast: async (id, updatedata) => {
    const { data } = await ovpFetch(`/live/broadcast/${id}`, {
      method: 'POST',
      body: JSON.stringify(updatedata),
    });
    return data;
  },

  getBroadcast: async (broadcastId) => {
    const { data } = await ovpFetch(`/live/broadcast/${broadcastId}`);
    return data;
  },

  schedule: async (payload) => {
    const { data } = await ovpFetch('/live/broadcast', {
      method: 'POST',
      body: JSON.stringify(payload),
    });
    return data.id;
  },

  stopBroadcast: async (broadcastId) => {
    const { data } = await ovpFetch(`/live/broadcast/${broadcastId}/transition`, {
      method: 'POST',
      body: JSON.stringify({ state: 'liveStopping' }),
    });
    return data;
  },

  getQuestions: async (broadcastId) => {
    const { data } = await ovpFetch(`/live/broadcast/${broadcastId}/questions`);
    return data;
  },

  toggleQ: async (broadcastId, questionId) => {
    await ovpFetch(`/live/broadcast/${broadcastId}/questions/${questionId}`, {
      method: 'POST',
    });
    return true;
  },

  deleteQ: async (broadcastId, questionId) => {
    await ovpFetch(`/live/broadcast/${broadcastId}/questions/${questionId}`, {
      method: 'DELETE',
    });
    return true;
  },

  answerQ: async (broadcastId, questionId, questionAnswer) => {
    await ovpFetch(`/live/broadcast/${broadcastId}/questions/${questionId}`, {
      method: 'POST',
      body: JSON.stringify({ answer: questionAnswer }),
    });
    return true;
  },

  getViews: async (broadcastId) => {
    const { data } = await ovpFetch(`/live/analytics/broadcast/${broadcastId}/views`);
    return data;
  },

  deleteBroadcast: async (id) => {
    await ovpFetch(`/live/broadcast/${id}`, {
      method: 'DELETE',
      iLikeItRaw: true,
    });
    return true;
  },

  uploadPoster: async (broadcastId, file) => {
    const { data } = await ovpFetch(`/live/broadcast/${broadcastId}/poster`, {
      method: 'POST',
      body: file,
      defaultContentType: true,
    });
    return data;
  },
};

// eslint-disable-next-line
export { BroadcastService };
